import invoiceIdMethods from './Invoices.id'

export const InvoiceServices = {
  id: {
    ...invoiceIdMethods
  }
}

export * from './Invoices.types'
